module.exports = __webpack_public_path__ + "media/images/bestsecret-4c4faf7beb586fa26f5060156df9a025.png";